<template lang="pug">
  v-pagination.pagination.pb-2(
    v-show="pagination.pages > 1",
    :value='currentPage',
    :length='pagination.pages',
    total-visible="10",
    @input="change",
  )
</template>

<script>
import { mergeRight } from 'ramda';

export default {
  name: 'Pagination',
  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      page: 1,
    };
  },

  computed: {
    currentPage() {
      return this.pagination.skip / this.pagination.limit + 1;
    },
  },

  methods: {
    change(page) {
      this.$emit(
        'changePage',
        mergeRight(this.pagination, {
          skip: this.pagination.limit * (page - 1),
        }),
      );
    },
  },
};
</script>
